import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { EditorStateService } from '../services/editor-state.service';

export const unsavedChangesGuard: CanDeactivateFn<any> = () => {
  const editorState = inject(EditorStateService);
  if (editorState.hasUnsavedChanges()) {
    editorState.showSaveWarning.set(true);
    return false;
  }
  return true;
};
